const body = document.body;
const main = document.getElementById('site-main');
const { settings } = JSON.parse(document.querySelector('[data-id="custom-header-settings"]').innerHTML)
const header = document.querySelector('.custom-header-wrapper');
const animationType = settings.animation_type.replaceAll('_', '-');
let lastScroll = 0;

header.classList.add(animationType)
window.addEventListener('scroll', () => {
    const headerHeight = header.offsetHeight;
    const currentScroll = window.pageYOffset;
    const hideAtTheBegining = (animationType == 'sticky-and-blur');
    if (currentScroll <= headerHeight) {
        body.classList.remove('scroll-up');
        return;
    }

    if (currentScroll > lastScroll
        && !body.classList.contains('scroll-down')
        && (hideAtTheBegining || currentScroll > headerHeight)) {
        // скролл вниз
        body.classList.remove('scroll-up');
        body.classList.add('scroll-down');
    } else if (
        currentScroll < lastScroll
        && body.classList.contains('scroll-down')
    ) {
        // сколл вверх
        body.classList.remove('scroll-down');
        body.classList.add('scroll-up');
    }
    lastScroll = currentScroll;
});

const fixHeaderHeigth = () => {
    const header = document.getElementById('shopify-section-custom-header')
    const navList = header.querySelector('.site-navigation > [data-navmenu]');
    const logo = header.querySelector('.site-logo');
    const headerActions = header.querySelector('.site-header-main-actions');
    const headerContent = header.querySelector('[data-site-header-main]')
    const headerStyles = window.getComputedStyle(headerContent);
    const headerWidth = headerContent.clientWidth - headerStyles.paddingLeft.replace('px', '');
    const navListWidth = navList.clientWidth;
    const headerActionsWidth = headerActions.clientWidth;
    const logoWidth = logo.clientWidth;
    const widestSide = headerActionsWidth > logoWidth ? headerActionsWidth : logoWidth;

    if (headerWidth / 2 <= navListWidth / 2 + widestSide) {
        headerContent.classList.add('site-header-stacked');
    } else {
        headerContent.classList.remove('site-header-stacked');
    }
}

/* Fix for header on tablet */
window.addEventListener('resize', fixHeaderHeigth);
fixHeaderHeigth();
